import {Model} from '@vuex-orm/core';

export default class Note extends Model {

    static entity = 'note';
    static primaryKey = 'id_note';

    static fields() {
        return {
            id_note: this.attr(null),
            type: this.attr(null),
            text: this.string(null),
            created_at: this.attr(null),
            id_creator: this.attr(null),
            id_user: this.attr(null),
            id_partner: this.attr(null),
            creator: this.attr(null),
            file: this.attr(null),
            archived: this.boolean(false),
        };
    }

}